import { isMobileView } from '@utils/toolbox';

export class CalendarRenderer {
	constructor (config) {
		this.html = config.html;
		this.open = false;
		this._callbacks = config.callbacks || {};

		this.selectors = {
			calendarRender: 'abCalendarWrapper',
			calendarRenderVisible: 'abCalendarWrapper--visible',
			calendarRenderHidden: 'abCalendarWrapper--hidden',
			title: 'abCalendarWrapper__title',
			closeBtn: 'abCalendarWrapper__close',
			applyBtn: 'abCalendarWrapper__apply',
			sliderBtns: 'abCalendarWrapper__slider',
			sliderBtnDisabled: 'abCalendarWrapper__slider--disabled'
		};

		this.events();

		return this;
	}

	adjustTopPosition (legNb = null) {
		let topPos = '';

		const isMobile = isMobileView();

		if (legNb && !isMobile) {
			const legHeight = document.querySelector('.abSearchBox__leg').offsetHeight;
			topPos = (legNb * legHeight - 7) + 'px';
			this.html.style.top = topPos;
		}

		return this;
	}

	show (legNb = null) {
		const isMobile = isMobileView();

		if (this._callbacks.onShow) {
			this._callbacks.onShow();
		}

		this.adjustTopPosition(legNb);

		this.html.classList.add(this.selectors.calendarRenderVisible);

		if (isMobile) {
			document.body.style.overflow = 'hidden';
		}

		this.open = true;

		return this;
	}

	blurField () {
		const classes = this.html.classList;
		const { calendarRenderVisible, calendarRenderHidden } = this.selectors;

		this.html.style.top = '';
		classes.remove(calendarRenderVisible);

		classes.remove(calendarRenderHidden);

		document.body.style.overflow = '';

		this.open = false;

		return this;
	}

	reset () {
		if (this._callbacks.onReset) {
			this._callbacks.onReset();
		}
	}

	hide () {
		if (this._callbacks.onHide) {
			this._callbacks.onHide();
		}

		this.blurField();
	}

	events () {
		this.html.addEventListener('click', (event) => {
			const elem = event.target;

			if (elem.matches(`.${this.selectors.closeBtn}`)) {
				this.reset();
				this.hide();

				return;
			}

			if (elem.matches(`.${this.selectors.applyBtn}`)) {
				if (this._callbacks.onApply) {
					this._callbacks.onApply(this);
				}

				this.hide();

				return;
			}

			if (elem.matches(`.${this.selectors.sliderBtns}`)) {
				if (elem.classList.contains(this.selectors.sliderBtnDisabled)) {
					return;
				}

				if (this._callbacks.onSlide) {
					this._callbacks.onSlide(elem.dataset.direction);
				}
			}
		});

		this.html.addEventListener('keyup', (event) => {
			if (event.key === 'Escape') {
				this.hide();
			}
		});
	}
}
